import Axios from 'axios'
import React, { Component } from 'react'
import config from '../../Shared/config'
import { calculateTimeDifference } from '../../Utils/Datetime'
import Token from '../../Utils/Token'
import './Profile.scss'
import Spinner from '../Spinner'

export default class Profile extends Component {
    constructor(props) {
        super(props)

        this.state = {
            parentInfoFetching: true,
            parentInfoFetched: false,
            recentActivityFetching: true,
            recentActivityFetched: false,
            parentForm: {
                fullNameMother: '',
                phoneMother: '',
                emailMother: '',
                fullNameFather: '',
                phoneFather: '',
                emailFather: ''
            },
            recentActivity: []
        }
    }

    componentDidMount() {
        let token = Token.getToken()
        if (!token) {
            this.props.history.push('/')
        } else {
            this.getParentInformation()
            this.getRecentActivity()
        }
    }

    getRecentActivity = () => {
        this.setState({
            recentActivityFetching: true
        })

        const url = `${config.apiUrl}/user/getRecentActivity`
        Axios.get(url).then(res => {
            if (!res.data.error) {
                this.setState({
                    recentActivity: res.data.data,
                    recentActivityFetched: true,
                    recentActivityFetching: false
                })
            } else {
                this.setState({
                    recentActivity: [],
                    recentActivityFetched: false,
                    recentActivityFetching: false
                })
                alert(res.data.message)
            }
        }).catch(err => {
            this.setState({
                recentActivity: [],
                recentActivityFetched: false,
                recentActivityFetching: false
            })
        })
    }

    getParentInformation = () => {
        let parentInfoFetched = false
        this.setState({
            parentInfoFetching: true
        })

        const url = `${config.apiUrl}/user/getParentInformation`
        Axios.get(url).then(res => {
            let parent = {
                fullNameMother: '',
                phoneMother: '',
                emailMother: '',
                fullNameFather: '',
                phoneFather: '',
                emailFather: ''
            }
            if (!res.data.error) {
                parent = res.data.data
                parentInfoFetched = true
            }
            this.setState({
                parentForm: parent,
                parentInfoFetching: false,
                parentInfoFetched: parentInfoFetched
            })
        }).catch(err => {
            this.setState({
                parentForm: {},
                parentInfoFetching: false,
                parentInfoFetched: parentInfoFetched
            })
        })
    }

    onChangeParentForm = (e) => {
        let { parentForm } = this.state
        parentForm[e.target.id] = e.target.value;
        this.setState({
            parentForm
        })
    }

    clearParentForm = () => {
        this.setState({
            parentForm: {
                fullNameMother: '',
                phoneMother: '',
                emailMother: '',
                fullNameFather: '',
                phoneFather: '',
                emailFather: ''
            }
        })
    }

    saveParentData = () => {
        const url = `${config.apiUrl}/user/updateParentInfo`
        let data = this.state.parentForm;
        Axios.post(url, data).then(res => {
            if (!res.data.error) {
                this.props.closeParentInfoAlert()
            }
            alert(res.data.message)
        }).catch(err => {

        })
    }

    render() {
        let { parentInfoFetching, parentInfoFetched, recentActivityFetching, recentActivityFetched } = this.state

        return (
            <div className="profile-container">
                <div className="container">

                    <section className='card-f parent-info-container'>
                        <h3>Parent's Information <img src='https://image.flaticon.com/icons/svg/788/788893.svg' alt='ask'></img></h3>

                        {
                            parentInfoFetching ? (
                                <Spinner />
                            ) : (
                                    parentInfoFetched ? (
                                        <div className="question-form">
                                            <div>Mother's Full Name</div>
                                            <div><input onChange={this.onChangeParentForm} value={this.state.parentForm['fullNameMother'] || ''} id='fullNameMother' type='text' className="input-field-main"></input></div>
                                            <div>Mother's Phone Number</div>
                                            <div><input onChange={this.onChangeParentForm} value={this.state.parentForm['phoneMother'] || ''} id='phoneMother' type='text' className="input-field-main"></input></div>
                                            <div>Mother's E-mail</div>
                                            <div><input onChange={this.onChangeParentForm} value={this.state.parentForm['emailMother'] || ''} id='emailMother' type='text' className="input-field-main"></input></div>
                                            <div>Father's Full Name</div>
                                            <div><input onChange={this.onChangeParentForm} value={this.state.parentForm['fullNameFather'] || ''} id='fullNameFather' type='text' className="input-field-main"></input></div>
                                            <div>Father's Phone Number</div>
                                            <div><input onChange={this.onChangeParentForm} value={this.state.parentForm['phoneFather'] || ''} id='phoneFather' type='text' className="input-field-main"></input></div>
                                            <div>Father's E-mail</div>
                                            <div><input onChange={this.onChangeParentForm} value={this.state.parentForm['emailFather'] || ''} id='emailFather' type='text' className="input-field-main"></input></div>
                                        </div>
                                    ) : (
                                            null
                                        )
                                )
                        }
                        {
                            parentInfoFetched ? (
                                <div className='actions'>
                                    <button onClick={this.clearParentForm} className='btn-new btn-danger'>Clear</button>
                                    <button onClick={this.saveParentData} className='btn-new btn-success'>Save</button>
                                </div>
                            ) : null
                        }
                    </section>

                    <section className='card-f recent-activity-container'>
                        <h3>Recent Activity <img src='https://image.flaticon.com/icons/svg/788/788893.svg' alt='ask'></img></h3>

                        {
                            recentActivityFetching ? (
                                <Spinner />
                            ) : (
                                    recentActivityFetched ? (
                                        <div className="activity-list">
                                            {
                                                this.state.recentActivity.map((item, idx) => {
                                                    return (
                                                        <div key={idx} className='recent-one'>
                                                            <div className='title'>{item.title}</div>
                                                            <div className='date-time'>{calculateTimeDifference(item.date)}</div>
                                                        </div>
                                                    )
                                                })
                                            }
                                        </div>
                                    ) : null
                                )
                        }
                    </section>

                </div>
            </div>
        )
    }
}
